import { render, staticRenderFns } from "./FeaturedInsights.vue?vue&type=template&id=33b5ea52&scoped=true&"
import script from "./FeaturedInsights.vue?vue&type=script&lang=js&"
export * from "./FeaturedInsights.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedInsights.vue?vue&type=style&index=0&id=33b5ea52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b5ea52",
  null
  
)

export default component.exports